"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromise = void 0;
var react_1 = require("react");
/**
 * Wrap a promise (creator function) in a React hook to access its result or error.
 * Use the dependencies list to control reevaluation of the promise creator function on subsequent renders.
 */
function usePromise(p, dependencies) {
    var _a = (0, react_1.useState)(), result = _a[0], setResult = _a[1];
    var _b = (0, react_1.useState)(), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(true), loading = _c[0], setLoading = _c[1];
    (0, react_1.useEffect)(function () {
        setLoading(true);
        p()
            .then(setResult, setError)
            .finally(function () { return setLoading(false); });
    }, dependencies);
    return [result, error, loading];
}
exports.usePromise = usePromise;
